// import {
//   Box, Typography, Chip, CircularProgress, Divider,
//   TextField, Button, IconButton, Snackbar, Alert,
//   Skeleton, Collapse,
// } from "@mui/material";
// import LocalOfferIcon    from "@mui/icons-material/LocalOffer";
// import BoltIcon          from "@mui/icons-material/Bolt";
// import CategoryIcon      from "@mui/icons-material/Category";
// import ShoppingCartIcon  from "@mui/icons-material/ShoppingCart";
// import DiscountIcon      from "@mui/icons-material/Discount";
// import ContentCopyIcon   from "@mui/icons-material/ContentCopy";
// import CheckCircleIcon   from "@mui/icons-material/CheckCircle";
// import ExpandMoreIcon    from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon    from "@mui/icons-material/ExpandLess";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchPublicOffers,
//   validateOfferCode,
//   selectAllOffers,
//   selectBogoOffers,
//   selectDiscountOffers,
//   selectCategoryOffers,
//   selectCartOffers,
//   selectItemOffers,
//   selectOffersLoading,
//   selectValidatedOffer,
//   selectValidatingOffer,
//   selectPublicError,
//   selectPublicSuccess,
//   clearPublicState,
//   clearValidatedOffer,
// } from "../../../redux/slices/publicSlice";

// // ─── Helpers ──────────────────────────────────────────────────────
// const discountLabel = (offer) => {
//   if (offer.offerCategory === "BOGO")      return `BUY ${offer.value} GET ${offer.getQuantity || 1}`;
//   if (offer.offerCategory === "FREE_ITEM") return "FREE ITEM";
//   if (offer.discountType === "PERCENT")    return `${offer.value}% OFF`;
//   if (offer.discountType === "FLAT")       return `₹${offer.value} OFF`;
//   return "OFFER";
// };

// const scopeColor = (scope) =>
//   ({ CART: "#1565c0", ITEM: "#2e7d32", CATEGORY: "#7b1fa2" })[scope] || "#555";

// // ─── Section Header ───────────────────────────────────────────────
// const SectionHeader = ({ icon, title, count, color = "#2e7d32" }) => (
//   <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
//     <Box sx={{ width: 32, height: 32, borderRadius: 1.5, bgcolor: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
//       {icon}
//     </Box>
//     <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: "0.95rem", flex: 1 }}>{title}</Typography>
//     {count != null && (
//       <Chip label={count} size="small" sx={{ height: 20, fontSize: "0.65rem", bgcolor: `${color}20`, color }} />
//     )}
//   </Box>
// );

// // ─── Offer Card ───────────────────────────────────────────────────
// const OfferCard = ({ offer, color = "#2e7d32", onCopy }) => {
//   const [expanded, setExpanded] = useState(false);

//   const expiryStr = offer.expiryDate
//     ? new Date(offer.expiryDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "2-digit" })
//     : null;

//   const isExpiringSoon = offer.expiryDate
//     ? (new Date(offer.expiryDate) - new Date()) < 1000 * 60 * 60 * 24 * 3
//     : false;

//   return (
//     <Box sx={{ borderRadius: 2.5, border: `1.5px dashed ${color}50`, bgcolor: "white", overflow: "hidden", mb: 1.2, boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
//       <Box sx={{ display: "flex", p: 1.5, gap: 1.5 }}>
//         {/* Badge */}
//         <Box sx={{ minWidth: 66, height: 66, borderRadius: 2, bgcolor: `${color}12`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0, border: `1.5px solid ${color}25` }}>
//           <Typography sx={{ fontSize: "0.58rem", fontWeight: 800, color, lineHeight: 1.2, textAlign: "center", px: 0.5 }}>
//             {discountLabel(offer)}
//           </Typography>
//         </Box>

//         {/* Text */}
//         <Box sx={{ flex: 1, overflow: "hidden" }}>
//           {/* ✅ offer.title */}
//           <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", mb: 0.3 }}>
//             {offer.title}
//           </Typography>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 0.4, flexWrap: "wrap" }}>
//             <Chip label={offer.scope} size="small" sx={{ height: 16, fontSize: "0.6rem", fontWeight: 700, bgcolor: `${scopeColor(offer.scope)}15`, color: scopeColor(offer.scope) }} />
//             {offer.scope === "ITEM" && offer.menuItem?.itemName && (
//               <Typography variant="caption" sx={{ color: "#666", fontSize: "0.7rem" }}>on {offer.menuItem.itemName}</Typography>
//             )}
//             {offer.scope === "CATEGORY" && offer.categoryId?.name && (
//               <Typography variant="caption" sx={{ color: "#666", fontSize: "0.7rem" }}>on {offer.categoryId.name}</Typography>
//             )}
//           </Box>

//           <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, flexWrap: "wrap" }}>
//             {offer.minQuantity > 1 && (
//               <Chip label={`Min qty: ${offer.minQuantity}`} size="small" sx={{ height: 17, fontSize: "0.6rem", bgcolor: "#fff3e0", color: "#e65100" }} />
//             )}
//             {offer.maxDiscount && (
//               <Chip label={`Max ₹${offer.maxDiscount}`} size="small" sx={{ height: 17, fontSize: "0.6rem", bgcolor: "#f3e5f5", color: "#7b1fa2" }} />
//             )}
//             {expiryStr && (
//               <Typography variant="caption" sx={{ fontSize: "0.65rem", color: isExpiringSoon ? "#e53935" : "#aaa", fontWeight: isExpiringSoon ? 700 : 400 }}>
//                 {isExpiringSoon ? "⚡ Expiring soon · " : "Till "}{expiryStr}
//               </Typography>
//             )}
//           </Box>
//         </Box>

//         <IconButton size="small" onClick={() => setExpanded(!expanded)} sx={{ alignSelf: "center", color: "#bbb", p: 0.3 }}>
//           {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
//         </IconButton>
//       </Box>

//       <Collapse in={expanded || !!offer.offerCode}>
//         <Divider />
//         <Box sx={{ px: 1.5, py: 0.9, display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: `${color}08` }}>
//           {offer.offerCode ? (
//             <>
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
//                 <Typography variant="caption" sx={{ color: "#888", fontSize: "0.7rem" }}>Code:</Typography>
//                 <Box sx={{ border: `1.5px dashed ${color}`, borderRadius: 1, px: 1, py: 0.2 }}>
//                   <Typography sx={{ fontWeight: 800, fontSize: "0.8rem", color, letterSpacing: 1.2 }}>{offer.offerCode}</Typography>
//                 </Box>
//               </Box>
//               <Button size="small" startIcon={<ContentCopyIcon sx={{ fontSize: "13px !important" }} />}
//                 onClick={() => onCopy(offer.offerCode)}
//                 sx={{ fontSize: "0.7rem", textTransform: "none", fontWeight: 700, color, py: 0.3, "&:hover": { bgcolor: `${color}15` } }}>
//                 Copy
//               </Button>
//             </>
//           ) : (
//             <Typography variant="caption" sx={{ color: "#888", fontSize: "0.72rem" }}>✓ Auto-applied at checkout</Typography>
//           )}
//         </Box>
//       </Collapse>
//     </Box>
//   );
// };

// const OfferSkeleton = () => <Skeleton variant="rectangular" height={84} sx={{ borderRadius: 2.5, mb: 1.2 }} />;

// // ─── Main Page ────────────────────────────────────────────────────
// const OffersPage = ({ restaurantId }) => {
//   const dispatch = useDispatch();

//   const allOffers      = useSelector(selectAllOffers);
//   const bogoOffers     = useSelector(selectBogoOffers);
//   const categoryOffers = useSelector(selectCategoryOffers);
//   const cartOffers     = useSelector(selectCartOffers);
//   const itemOffers     = useSelector(selectItemOffers);
//   const loading        = useSelector(selectOffersLoading);
//   const validatedOffer = useSelector(selectValidatedOffer);
//   const validating     = useSelector(selectValidatingOffer);
//   const error          = useSelector(selectPublicError);
//   const success        = useSelector(selectPublicSuccess);

//   const cart      = useSelector((s) => s.cart?.items || []);
//   const cartTotal = cart.reduce((n, i) => n + (i.totalPrice || 0) * (i.qty || 1), 0);

//   const [promoCode, setPromoCode] = useState("");
//   const [toast, setToast]         = useState({ open: false, msg: "", severity: "success" });

//   useEffect(() => {
//     if (restaurantId) dispatch(fetchPublicOffers(restaurantId));
//   }, [restaurantId, dispatch]);

//   useEffect(() => {
//     if (success) { setToast({ open: true, msg: success, severity: "success" }); dispatch(clearPublicState()); }
//     if (error)   { setToast({ open: true, msg: error,   severity: "error"   }); dispatch(clearPublicState()); }
//   }, [success, error, dispatch]);

//   const handleCopy = (code) => {
//     navigator.clipboard.writeText(code).then(() =>
//       setToast({ open: true, msg: `"${code}" copied! 📋`, severity: "success" })
//     );
//   };

//   const handleValidateCode = () => {
//     if (!promoCode.trim()) return;
//     dispatch(validateOfferCode({ restaurantId, offerCode: promoCode.trim().toUpperCase(), cartItems: cart, cartTotal }))
//       .unwrap()
//       .then(() => setToast({ open: true, msg: "Promo code applied! 🎉", severity: "success" }))
//       .catch((err) => setToast({ open: true, msg: err || "Invalid or expired code", severity: "error" }));
//   };

//   // ── Build lists from real API data ────────────────────────────
//   const bogoList         = bogoOffers || [];
//   const cartDiscountList = cartOffers || [];
//   const itemOfferList    = Object.values(itemOffers   || {}).flat();
//   const categoryOfferList = Object.values(categoryOffers || {}).flat();
//   const freeItemList     = (allOffers || []).filter((o) => o.offerCategory === "FREE_ITEM");

//   const isEmpty = !loading && !bogoList.length && !cartDiscountList.length && !itemOfferList.length && !categoryOfferList.length && !freeItemList.length;

//   return (
//     <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 2 }}>
//       {/* Header */}
//       <Box sx={{ background: "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)", px: 2, pt: 3, pb: 4,  }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
//           <LocalOfferIcon sx={{ color: "#a5d6a7", fontSize: 20 }} />
//           <Typography variant="h6" sx={{ color: "white", fontWeight: 800, fontSize: "1.1rem" }}>Offers & Deals</Typography>
//         </Box>
//         <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.75rem" }}>
//           {loading ? "Loading..." : `${allOffers?.length || 0} active offer${allOffers?.length !== 1 ? "s" : ""} for you`}
//         </Typography>
//       </Box>

//       {/* Promo code */}
//       <Box sx={{ mx: 2, mt: -2, mb: 2, position: "relative", zIndex: 1 }}>
//         <Box sx={{ borderRadius: 3, p: 2, border: "1px solid #e8f5e9", bgcolor: "white", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
//           <Typography variant="body2" sx={{ fontWeight: 700, mb: 1, fontSize: "0.85rem" }}>🎟️ Have a promo code?</Typography>
//           {validatedOffer ? (
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.2, bgcolor: "#e8f5e9", borderRadius: 2 }}>
//               <CheckCircleIcon sx={{ fontSize: 20, color: "#2e7d32" }} />
//               <Box sx={{ flex: 1 }}>
//                 <Typography variant="caption" sx={{ fontWeight: 700, color: "#2e7d32", display: "block", fontSize: "0.8rem" }}>
//                   "{validatedOffer.offerCode}" applied!
//                 </Typography>
//                 <Typography variant="caption" sx={{ color: "#555", fontSize: "0.72rem" }}>
//                   {/* ✅ API validateOfferCode returns discountAmount */}
//                   You save ₹{(validatedOffer.discountAmount || 0).toFixed(0)}
//                 </Typography>
//               </Box>
//               <IconButton size="small" onClick={() => { dispatch(clearValidatedOffer()); setPromoCode(""); }} sx={{ p: 0.5, color: "#aaa", fontSize: "0.9rem" }}>✕</IconButton>
//             </Box>
//           ) : (
//             <Box sx={{ display: "flex", gap: 1 }}>
//               <TextField size="small" placeholder="e.g. SPERJMT56A6"
//                 value={promoCode} onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
//                 onKeyDown={(e) => e.key === "Enter" && handleValidateCode()}
//                 sx={{ flex: 1, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: "0.85rem", height: 38, "& fieldset": { borderColor: "#e0e0e0" }, "&.Mui-focused fieldset": { borderColor: "#2e7d32" } } }}
//                 inputProps={{ style: { fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase" } }}
//               />
//               <Button variant="contained" size="small" onClick={handleValidateCode}
//                 disabled={validating || !promoCode.trim()}
//                 sx={{ bgcolor: "#2e7d32", "&:hover": { bgcolor: "#1b5e20" }, borderRadius: 2, textTransform: "none", fontWeight: 700, minWidth: 76, fontSize: "0.8rem", height: 38 }}>
//                 {validating ? <CircularProgress size={16} sx={{ color: "white" }} /> : "Apply"}
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Box>

//       {/* Offer Sections */}
//       <Box sx={{ px: 2 }}>
//         {isEmpty && (
//           <Box sx={{ textAlign: "center", py: 8 }}>
//             {/* <Typography sx={{ fontSize: "3rem", mb: 1 }}>🎁</Typography> */}
//             <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#333" }}>No active offers right now</Typography>
//             <Typography variant="caption" sx={{ color: "#888" }}>Check back later for exciting deals!</Typography>
//           </Box>
//         )}

//         {(loading || bogoList.length > 0) && (
//           <Box sx={{ mb: 3 }}>
//             <SectionHeader icon={<BoltIcon sx={{ fontSize: 18, color: "#e53935" }} />} title="Buy 1 Get 1" count={loading ? null : bogoList.length} color="#e53935" />
//             {loading ? [1,2].map(i => <OfferSkeleton key={i} />) : bogoList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#e53935" onCopy={handleCopy} />)}
//           </Box>
//         )}

//         {(loading || cartDiscountList.length > 0) && (
//           <Box sx={{ mb: 3 }}>
//             <SectionHeader icon={<ShoppingCartIcon sx={{ fontSize: 18, color: "#1565c0" }} />} title="Cart Discounts" count={loading ? null : cartDiscountList.length} color="#1565c0" />
//             {loading ? [1].map(i => <OfferSkeleton key={i} />) : cartDiscountList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#1565c0" onCopy={handleCopy} />)}
//           </Box>
//         )}

//         {(loading || itemOfferList.length > 0) && (
//           <Box sx={{ mb: 3 }}>
//             <SectionHeader icon={<DiscountIcon sx={{ fontSize: 18, color: "#2e7d32" }} />} title="Item Offers" count={loading ? null : itemOfferList.length} color="#2e7d32" />
//             {loading ? [1].map(i => <OfferSkeleton key={i} />) : itemOfferList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#2e7d32" onCopy={handleCopy} />)}
//           </Box>
//         )}

//         {(loading || categoryOfferList.length > 0) && (
//           <Box sx={{ mb: 3 }}>
//             <SectionHeader icon={<CategoryIcon sx={{ fontSize: 18, color: "#7b1fa2" }} />} title="Category Offers" count={loading ? null : categoryOfferList.length} color="#7b1fa2" />
//             {loading ? [1].map(i => <OfferSkeleton key={i} />) : categoryOfferList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#7b1fa2" onCopy={handleCopy} />)}
//           </Box>
//         )}

//         {(loading || freeItemList.length > 0) && (
//           <Box sx={{ mb: 3 }}>
//             <SectionHeader icon={<LocalOfferIcon sx={{ fontSize: 18, color: "#f59e0b" }} />} title="Free Item Offers" count={loading ? null : freeItemList.length} color="#f59e0b" />
//             {loading ? [1].map(i => <OfferSkeleton key={i} />) : freeItemList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#f59e0b" onCopy={handleCopy} />)}
//           </Box>
//         )}

//         {!loading && !isEmpty && (
//           <Typography variant="caption" sx={{ color: "#ccc", display: "block", textAlign: "center", mt: 1, fontSize: "0.7rem" }}>
//             * All offers subject to availability. T&C apply.
//           </Typography>
//         )}
//       </Box>

//       <Snackbar open={toast.open} autoHideDuration={2500} onClose={() => setToast({...toast, open: false})}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }} sx={{ bottom: 70 }}>
//         <Alert severity={toast.severity} variant="filled" sx={{ borderRadius: 2, fontSize: "0.8rem" }}>{toast.msg}</Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default OffersPage;
import {
  Box, Typography, Chip, CircularProgress, Divider,
  TextField, Button, IconButton, Snackbar, Alert,
  Skeleton, Collapse,
} from "@mui/material";
import LocalOfferIcon    from "@mui/icons-material/LocalOffer";
import BoltIcon          from "@mui/icons-material/Bolt";
import CategoryIcon      from "@mui/icons-material/Category";
import ShoppingCartIcon  from "@mui/icons-material/ShoppingCart";
import DiscountIcon      from "@mui/icons-material/Discount";
import ContentCopyIcon   from "@mui/icons-material/ContentCopy";
import CheckCircleIcon   from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon    from "@mui/icons-material/ExpandMore";
import ExpandLessIcon    from "@mui/icons-material/ExpandLess";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../../context/SocketContext";
import {
  fetchPublicOffers,
  validateOfferCode,
  selectAllOffers,
  selectBogoOffers,
  selectDiscountOffers,
  selectCategoryOffers,
  selectCartOffers,
  selectItemOffers,
  selectOffersLoading,
  selectValidatedOffer,
  selectValidatingOffer,
  selectPublicError,
  selectPublicSuccess,
  clearPublicState,
  clearValidatedOffer,
} from "../../../redux/slices/publicSlice";

// ─── Helpers ──────────────────────────────────────────────────────
const discountLabel = (offer) => {
  if (offer.offerCategory === "BOGO")      return `BUY ${offer.value} GET ${offer.getQuantity || 1}`;
  if (offer.offerCategory === "FREE_ITEM") return "FREE ITEM";
  if (offer.discountType === "PERCENT")    return `${offer.value}% OFF`;
  if (offer.discountType === "FLAT")       return `₹${offer.value} OFF`;
  return "OFFER";
};

const scopeColor = (scope) =>
  ({ CART: "#1565c0", ITEM: "#2e7d32", CATEGORY: "#7b1fa2" })[scope] || "#555";

// ─── Section Header ───────────────────────────────────────────────
const SectionHeader = ({ icon, title, count, color = "#2e7d32" }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
    <Box sx={{ width: 32, height: 32, borderRadius: 1.5, bgcolor: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
      {icon}
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: "0.95rem", flex: 1 }}>{title}</Typography>
    {count != null && (
      <Chip label={count} size="small" sx={{ height: 20, fontSize: "0.65rem", bgcolor: `${color}20`, color }} />
    )}
  </Box>
);

// ─── Offer Card ───────────────────────────────────────────────────
const OfferCard = ({ offer, color = "#2e7d32", onCopy }) => {
  const [expanded, setExpanded] = useState(false);
  const isActive = offer.isActive !== false;

  const expiryStr = offer.expiryDate
    ? new Date(offer.expiryDate).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "2-digit" })
    : null;

  const isExpiringSoon = offer.expiryDate
    ? (new Date(offer.expiryDate) - new Date()) < 1000 * 60 * 60 * 24 * 3
    : false;

  return (
    <Box sx={{ 
      borderRadius: 2.5, 
      border: `1.5px dashed ${isActive ? color : '#ccc'}50`, 
      bgcolor: isActive ? "white" : "#f5f5f5", 
      overflow: "hidden", 
      mb: 1.2, 
      boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
      opacity: isActive ? 1 : 0.6,
    }}>
      {/* ✅ Show inactive badge */}
      {!isActive && (
        <Box sx={{ 
          bgcolor: "#ef4444", 
          py: 0.3, 
          textAlign: "center",
        }}>
          <Typography sx={{ 
            color: "white", 
            fontSize: "0.65rem", 
            fontWeight: 700,
            letterSpacing: 0.5
          }}>
            INACTIVE
          </Typography>
        </Box>
      )}
      
      <Box sx={{ display: "flex", p: 1.5, gap: 1.5 }}>
        {/* Badge */}
        <Box sx={{ minWidth: 66, height: 66, borderRadius: 2, bgcolor: `${color}12`, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexShrink: 0, border: `1.5px solid ${color}25` }}>
          <Typography sx={{ fontSize: "0.58rem", fontWeight: 800, color, lineHeight: 1.2, textAlign: "center", px: 0.5 }}>
            {discountLabel(offer)}
          </Typography>
        </Box>

        {/* Text */}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <Typography variant="body2" sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", mb: 0.3 }}>
            {offer.title}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 0.4, flexWrap: "wrap" }}>
            <Chip label={offer.scope} size="small" sx={{ height: 16, fontSize: "0.6rem", fontWeight: 700, bgcolor: `${scopeColor(offer.scope)}15`, color: scopeColor(offer.scope) }} />
            {offer.scope === "ITEM" && offer.menuItem?.itemName && (
              <Typography variant="caption" sx={{ color: "#666", fontSize: "0.7rem" }}>on {offer.menuItem.itemName}</Typography>
            )}
            {offer.scope === "CATEGORY" && offer.categoryId?.name && (
              <Typography variant="caption" sx={{ color: "#666", fontSize: "0.7rem" }}>on {offer.categoryId.name}</Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, flexWrap: "wrap" }}>
            {offer.minQuantity > 1 && (
              <Chip label={`Min qty: ${offer.minQuantity}`} size="small" sx={{ height: 17, fontSize: "0.6rem", bgcolor: "#fff3e0", color: "#e65100" }} />
            )}
            {offer.maxDiscount && (
              <Chip label={`Max ₹${offer.maxDiscount}`} size="small" sx={{ height: 17, fontSize: "0.6rem", bgcolor: "#f3e5f5", color: "#7b1fa2" }} />
            )}
            {expiryStr && (
              <Typography variant="caption" sx={{ fontSize: "0.65rem", color: isExpiringSoon ? "#e53935" : "#aaa", fontWeight: isExpiringSoon ? 700 : 400 }}>
                {isExpiringSoon ? "⚡ Expiring soon · " : "Till "}{expiryStr}
              </Typography>
            )}
          </Box>
        </Box>

        <IconButton size="small" onClick={() => setExpanded(!expanded)} sx={{ alignSelf: "center", color: "#bbb", p: 0.3 }}>
          {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      </Box>

      <Collapse in={expanded || !!offer.offerCode}>
        <Divider />
        <Box sx={{ px: 1.5, py: 0.9, display: "flex", alignItems: "center", justifyContent: "space-between", bgcolor: `${color}08` }}>
          {offer.offerCode ? (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                <Typography variant="caption" sx={{ color: "#888", fontSize: "0.7rem" }}>Code:</Typography>
                <Box sx={{ border: `1.5px dashed ${color}`, borderRadius: 1, px: 1, py: 0.2 }}>
                  <Typography sx={{ fontWeight: 800, fontSize: "0.8rem", color, letterSpacing: 1.2 }}>{offer.offerCode}</Typography>
                </Box>
              </Box>
              <Button size="small" startIcon={<ContentCopyIcon sx={{ fontSize: "13px !important" }} />}
                onClick={() => onCopy(offer.offerCode)}
                sx={{ fontSize: "0.7rem", textTransform: "none", fontWeight: 700, color, py: 0.3, "&:hover": { bgcolor: `${color}15` } }}>
                Copy
              </Button>
            </>
          ) : (
            <Typography variant="caption" sx={{ color: "#888", fontSize: "0.72rem" }}>✓ Auto-applied at checkout</Typography>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};

const OfferSkeleton = () => <Skeleton variant="rectangular" height={84} sx={{ borderRadius: 2.5, mb: 1.2 }} />;

// ─── Main Page ────────────────────────────────────────────────────
const OffersPage = ({ restaurantId }) => {
  const dispatch = useDispatch();
  const { socket, isConnected } = useSocket();

  const allOffers      = useSelector(selectAllOffers);
  const bogoOffers     = useSelector(selectBogoOffers);
  const categoryOffers = useSelector(selectCategoryOffers);
  const cartOffers     = useSelector(selectCartOffers);
  const itemOffers     = useSelector(selectItemOffers);
  const loading        = useSelector(selectOffersLoading);
  const validatedOffer = useSelector(selectValidatedOffer);
  const validating     = useSelector(selectValidatingOffer);
  const error          = useSelector(selectPublicError);
  const success        = useSelector(selectPublicSuccess);

  const cart      = useSelector((s) => s.cart?.items || []);
  const cartTotal = cart.reduce((n, i) => n + (i.totalPrice || 0) * (i.qty || 1), 0);

  const [promoCode, setPromoCode] = useState("");
  const [toast, setToast]         = useState({ open: false, msg: "", severity: "success" });
  const [notification, setNotification] = useState(null);

  // ============================================
  // ✅ FETCH OFFERS ON MOUNT
  // ============================================
  useEffect(() => {
    if (restaurantId) dispatch(fetchPublicOffers(restaurantId));
  }, [restaurantId, dispatch]);

  // ============================================
  // ✅ JOIN PUBLIC ROOM FOR REAL-TIME UPDATES
  // ============================================
  useEffect(() => {
    if (!socket || !isConnected || !restaurantId) {
      console.log(" Socket not ready for OffersPage");
      return;
    }

    // console.log("Joining public room for offers:", restaurantId);
    socket.emit("public-join", { restaurantId });

    socket.on("public-join-confirm", (data) => {
      console.log("Public join confirmed for offers:", data);
    });

    return () => {
      socket.emit("public-leave", { restaurantId });
      socket.off("public-join-confirm");
    };
  }, [socket, isConnected, restaurantId]);

  // ============================================
  // ✅ SOCKET EVENT LISTENERS - REAL-TIME OFFERS
  // ============================================
  useEffect(() => {
    if (!socket || !isConnected || !restaurantId) {
      console.log("Socket not ready for OffersPage listeners");
      return;
    }

    // console.log("📡 Setting up OffersPage socket listeners");

    // ============================================
    // 1️⃣ NEW OFFER ADDED
    // ============================================
    const handleNewOffer = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      setNotification({
        message: `🎉 New offer: ${data.offer?.title || 'New offer'} available!`,
        severity: "success",
      });
      setTimeout(() => setNotification(null), 4000);
    };

    // ============================================
    // 2️⃣ OFFER UPDATED
    // ============================================
    const handleOfferUpdated = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      if (data.offer) {
        const isActive = data.offer.isActive !== false;
        setNotification({
          message: isActive 
            ? `🔄 Offer "${data.offer.title}" has been updated` 
            : `⏳ Offer "${data.offer.title}" is no longer available`,
          severity: isActive ? "info" : "warning",
        });
        setTimeout(() => setNotification(null), 3000);
      }
    };

    // ============================================
    // 3️⃣ OFFER STATUS CHANGED (ACTIVE/INACTIVE)
    // ============================================
    const handleOfferStatusChanged = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      let offerTitle = 'Offer';
      let isActive = false;
      
      if (data.offer) {
        offerTitle = data.offer.title || 'Offer';
        isActive = data.offer.isActive !== false;
      } else if (data.offerTitle) {
        offerTitle = data.offerTitle;
        isActive = data.isActive !== false;
      }
      
      setNotification({
        message: isActive 
          ? `🎉 Offer "${offerTitle}" is now active!` 
          : `⏳ Offer "${offerTitle}" has ended`,
        severity: isActive ? "success" : "warning",
      });
      setTimeout(() => setNotification(null), 3000);
    };

    // ============================================
    // 4️⃣ OFFER TOGGLED
    // ============================================
    const handleOfferToggled = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      if (data.offer) {
        setNotification({
          message: data.offer.isActive 
            ? `🎉 Offer "${data.offer.title}" is now active!` 
            : `⏳ Offer "${data.offer.title}" has been deactivated`,
          severity: data.offer.isActive ? "success" : "warning",
        });
        setTimeout(() => setNotification(null), 3000);
      }
    };

    // ============================================
    // 5️⃣ OFFER DEACTIVATED
    // ============================================
    const handleOfferDeactivated = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      setNotification({
        message: `❌ Offer "${data.offerTitle || 'Offer'}" has ended`,
        severity: "warning",
      });
      setTimeout(() => setNotification(null), 3000);
    };

    // ============================================
    // 6️⃣ OFFER DELETED
    // ============================================
    const handleOfferDeleted = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      setNotification({
        message: `🗑️ Offer "${data.offerTitle || 'Offer'}" has been removed`,
        severity: "warning",
      });
      setTimeout(() => setNotification(null), 3000);
    };

    // ============================================
    // 7️⃣ BOGO OFFER ADDED
    // ============================================
    const handleBogoOfferAdded = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      setNotification({
        message: `🔄 New BOGO offer: ${data.offer?.title || 'Buy 1 Get 1'} available!`,
        severity: "success",
      });
      setTimeout(() => setNotification(null), 4000);
    };

    // ============================================
    // 8️⃣ CART OFFER ADDED
    // ============================================
    const handleCartOfferAdded = (data) => {
      dispatch(fetchPublicOffers(restaurantId));
      
      setNotification({
        message: `🛒 New cart discount: ${data.offer?.title || 'New offer'} available!`,
        severity: "success",
      });
      setTimeout(() => setNotification(null), 4000);
    };

    // ============================================
    // 9️⃣ OFFER VALIDATED
    // ============================================
    const handleOfferValidated = (data) => {
      
      if (data.isValid && data.offer) {
        setNotification({
          message: `✅ Offer "${data.offer.title}" is valid!`,
          severity: "success",
        });
        setTimeout(() => setNotification(null), 3000);
      } else if (!data.isValid) {
        setNotification({
          message: `❌ ${data.message || 'Invalid offer code'}`,
          severity: "error",
        });
        setTimeout(() => setNotification(null), 3000);
      }
    };

    // ============================================
    // 🔟 OFFER CLAIMED
    // ============================================
    const handleOfferClaimed = (data) => {
      
      if (data.offer) {
        setNotification({
          message: `🏷️ ${data.userName || 'Someone'} claimed "${data.offer.title}"`,
          severity: "info",
        });
        setTimeout(() => setNotification(null), 3000);
      }
    };

    // ✅ Register all offer-related socket events
    socket.on("new-offer", handleNewOffer);
    socket.on("offer-updated", handleOfferUpdated);
    socket.on("offer-status-changed", handleOfferStatusChanged);
    socket.on("offer-toggled", handleOfferToggled);
    socket.on("offer-deactivated", handleOfferDeactivated);
    socket.on("offer-deleted", handleOfferDeleted);
    socket.on("bogo-offer-added", handleBogoOfferAdded);
    socket.on("cart-offer-added", handleCartOfferAdded);
    socket.on("offer-validated", handleOfferValidated);
    socket.on("offer-claimed", handleOfferClaimed);

    // Also listen for any offer-related events with different names
    socket.on("offer-active-toggled", handleOfferToggled);
    socket.on("offer-toggle", handleOfferToggled);

    // Debug listener to see all events (optional - remove in production)
    socket.onAny((eventName, ...args) => {
      console.log(`📨 OFFERS PAGE EVENT: ${eventName}`, args);
    });

    // ✅ Cleanup
    return () => {
      socket.off("new-offer", handleNewOffer);
      socket.off("offer-updated", handleOfferUpdated);
      socket.off("offer-status-changed", handleOfferStatusChanged);
      socket.off("offer-toggled", handleOfferToggled);
      socket.off("offer-deactivated", handleOfferDeactivated);
      socket.off("offer-deleted", handleOfferDeleted);
      socket.off("bogo-offer-added", handleBogoOfferAdded);
      socket.off("cart-offer-added", handleCartOfferAdded);
      socket.off("offer-validated", handleOfferValidated);
      socket.off("offer-claimed", handleOfferClaimed);
      socket.off("offer-active-toggled", handleOfferToggled);
      socket.off("offer-toggle", handleOfferToggled);
      socket.offAny(); // Remove debug listener
    };
  }, [socket, isConnected, restaurantId, dispatch]);

  // ============================================
  // ✅ TOAST NOTIFICATIONS
  // ============================================
  useEffect(() => {
    if (success) { 
      setToast({ open: true, msg: success, severity: "success" }); 
      dispatch(clearPublicState()); 
    }
    if (error)   { 
      setToast({ open: true, msg: error,   severity: "error"   }); 
      dispatch(clearPublicState()); 
    }
  }, [success, error, dispatch]);

  // ============================================
  // ✅ HANDLERS
  // ============================================
  const handleCopy = (code) => {
    navigator.clipboard.writeText(code).then(() =>
      setToast({ open: true, msg: `"${code}" copied! 📋`, severity: "success" })
    );
  };

  const handleValidateCode = () => {
    if (!promoCode.trim()) return;
    dispatch(validateOfferCode({ 
      restaurantId, 
      offerCode: promoCode.trim().toUpperCase(), 
      cartItems: cart, 
      cartTotal 
    }))
      .unwrap()
      .then(() => {
        setToast({ open: true, msg: "Promo code applied! 🎉", severity: "success" });
        if (socket && isConnected) {
          socket.emit("offer-validate", { 
            restaurantId, 
            offerCode: promoCode.trim().toUpperCase(),
            userId: 'anonymous'
          });
        }
      })
      .catch((err) => setToast({ open: true, msg: err || "Invalid or expired code", severity: "error" }));
  };

  // ── Filter out inactive offers ────────────────────────────────
  const bogoList = (bogoOffers || []).filter(o => o.isActive !== false);
  const cartDiscountList = (cartOffers || []).filter(o => o.isActive !== false);
  const itemOfferList = Object.values(itemOffers || {}).flat().filter(o => o.isActive !== false);
  const categoryOfferList = Object.values(categoryOffers || {}).flat().filter(o => o.isActive !== false);
  const freeItemList = (allOffers || []).filter(o => o.offerCategory === "FREE_ITEM" && o.isActive !== false);

  const isEmpty = !loading && !bogoList.length && !cartDiscountList.length && !itemOfferList.length && !categoryOfferList.length && !freeItemList.length;

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", pb: 2 }}>
      <Box sx={{ background: "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)", px: 2, pt: 3, pb: 4 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
          <LocalOfferIcon sx={{ color: "#a5d6a7", fontSize: 20 }} />
          <Typography variant="h6" sx={{ color: "white", fontWeight: 800, fontSize: "1.1rem" }}>Offers & Deals</Typography>
        </Box>
        <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.75rem" }}>
          {loading ? "Loading..." : `${allOffers?.length || 0} active offer${allOffers?.length !== 1 ? "s" : ""} for you`}
        </Typography>
      </Box>

      {/* Promo code */}
      <Box sx={{ mx: 2, mt: -2, mb: 2, position: "relative", zIndex: 1 }}>
        <Box sx={{ borderRadius: 3, p: 2, border: "1px solid #e8f5e9", bgcolor: "white", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
          <Typography variant="body2" sx={{ fontWeight: 700, mb: 1, fontSize: "0.85rem" }}>🎟️ Have a promo code?</Typography>
          {validatedOffer ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.2, bgcolor: "#e8f5e9", borderRadius: 2 }}>
              <CheckCircleIcon sx={{ fontSize: 20, color: "#2e7d32" }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" sx={{ fontWeight: 700, color: "#2e7d32", display: "block", fontSize: "0.8rem" }}>
                  "{validatedOffer.offerCode}" applied!
                </Typography>
                <Typography variant="caption" sx={{ color: "#555", fontSize: "0.72rem" }}>
                  You save ₹{(validatedOffer.discountAmount || 0).toFixed(0)}
                </Typography>
              </Box>
              <IconButton size="small" onClick={() => { dispatch(clearValidatedOffer()); setPromoCode(""); }} sx={{ p: 0.5, color: "#aaa", fontSize: "0.9rem" }}>✕</IconButton>
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField size="small" placeholder="e.g. SPERJMT56A6"
                value={promoCode} onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                onKeyDown={(e) => e.key === "Enter" && handleValidateCode()}
                sx={{ flex: 1, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: "0.85rem", height: 38, "& fieldset": { borderColor: "#e0e0e0" }, "&.Mui-focused fieldset": { borderColor: "#2e7d32" } } }}
                inputProps={{ style: { fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase" } }}
              />
              <Button variant="contained" size="small" onClick={handleValidateCode}
                disabled={validating || !promoCode.trim()}
                sx={{ bgcolor: "#2e7d32", "&:hover": { bgcolor: "#1b5e20" }, borderRadius: 2, textTransform: "none", fontWeight: 700, minWidth: 76, fontSize: "0.8rem", height: 38 }}>
                {validating ? <CircularProgress size={16} sx={{ color: "white" }} /> : "Apply"}
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      {/* Offer Sections */}
      <Box sx={{ px: 2 }}>
        {isEmpty && (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#333" }}>No active offers right now</Typography>
            <Typography variant="caption" sx={{ color: "#888" }}>Check back later for exciting deals!</Typography>
          </Box>
        )}

        {(loading || bogoList.length > 0) && (
          <Box sx={{ mb: 3 }}>
            <SectionHeader icon={<BoltIcon sx={{ fontSize: 18, color: "#e53935" }} />} title="Buy 1 Get 1" count={loading ? null : bogoList.length} color="#e53935" />
            {loading ? [1,2].map(i => <OfferSkeleton key={i} />) : bogoList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#e53935" onCopy={handleCopy} />)}
          </Box>
        )}

        {(loading || cartDiscountList.length > 0) && (
          <Box sx={{ mb: 3 }}>
            <SectionHeader icon={<ShoppingCartIcon sx={{ fontSize: 18, color: "#1565c0" }} />} title="Cart Discounts" count={loading ? null : cartDiscountList.length} color="#1565c0" />
            {loading ? [1].map(i => <OfferSkeleton key={i} />) : cartDiscountList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#1565c0" onCopy={handleCopy} />)}
          </Box>
        )}

        {(loading || itemOfferList.length > 0) && (
          <Box sx={{ mb: 3 }}>
            <SectionHeader icon={<DiscountIcon sx={{ fontSize: 18, color: "#2e7d32" }} />} title="Item Offers" count={loading ? null : itemOfferList.length} color="#2e7d32" />
            {loading ? [1].map(i => <OfferSkeleton key={i} />) : itemOfferList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#2e7d32" onCopy={handleCopy} />)}
          </Box>
        )}

        {(loading || categoryOfferList.length > 0) && (
          <Box sx={{ mb: 3 }}>
            <SectionHeader icon={<CategoryIcon sx={{ fontSize: 18, color: "#7b1fa2" }} />} title="Category Offers" count={loading ? null : categoryOfferList.length} color="#7b1fa2" />
            {loading ? [1].map(i => <OfferSkeleton key={i} />) : categoryOfferList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#7b1fa2" onCopy={handleCopy} />)}
          </Box>
        )}

        {(loading || freeItemList.length > 0) && (
          <Box sx={{ mb: 3 }}>
            <SectionHeader icon={<LocalOfferIcon sx={{ fontSize: 18, color: "#f59e0b" }} />} title="Free Item Offers" count={loading ? null : freeItemList.length} color="#f59e0b" />
            {loading ? [1].map(i => <OfferSkeleton key={i} />) : freeItemList.map((o,i) => <OfferCard key={o._id||i} offer={o} color="#f59e0b" onCopy={handleCopy} />)}
          </Box>
        )}

        {!loading && !isEmpty && (
          <Typography variant="caption" sx={{ color: "#ccc", display: "block", textAlign: "center", mt: 1, fontSize: "0.7rem" }}>
            * All offers subject to availability. T&C apply.
          </Typography>
        )}
      </Box>

      <Snackbar open={toast.open} autoHideDuration={2500} onClose={() => setToast({...toast, open: false})}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }} sx={{ bottom: 70 }}>
        <Alert severity={toast.severity} variant="filled" sx={{ borderRadius: 2, fontSize: "0.8rem" }}>{toast.msg}</Alert>
      </Snackbar>

      {/* Pulse Animation */}
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(1.2); }
          }
        `}
      </style>
    </Box>
  );
};

export default OffersPage;